import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PreloadGestionStrategy } from './core/strategies/preload-gestion.strategy';
import { AutenticacionGuard } from './core/guards/autenticacion.guard';
import { SoloOnlineGuard } from './core/guards/solo-online.guard';
import { RutaDelDiaGuard } from './core/guards/ruta-del-dia.guard';
import { YaAutenticadoGuard } from './core/guards/ya-autenticado.guard';
import { SesionApiOCampoGuard } from './core/guards/sesion-api-o-campo.guard';

const authOnline = [SoloOnlineGuard, AutenticacionGuard];
/** Configuración: sesión API o snapshot de campo sin red (simular offline). */
const authConfiguracion = [SesionApiOCampoGuard];

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    redirectTo: 'inicio',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./features/auth/login/login.module').then(m => m.LoginPageModule),
    canActivate: [YaAutenticadoGuard]
  },
  { 
    path: 'callback', 
    loadChildren: () => import('./features/auth/login/callback.module').then(m => m.CallbackModule) 
  },
  {
    path: 'login2',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'registro',
    loadChildren: () => import('./features/auth/registro/registro.module').then(m => m.RegistroPageModule)
  },
  {
    path: 'terminos',
    loadChildren: () => import('./features/auth/terminos/terminos.module').then(m => m.TerminosPageModule),
    canActivate: authOnline
  },
  {
    path: 'terminos-de-uso',
    loadChildren: () => import('./features/legal/legal.module').then(m => m.LegalPageModule)
  },
  {
    path: 'politica-de-privacidad',
    loadChildren: () => import('./features/legal/legal.module').then(m => m.LegalPageModule)
  },
  {
    path: 'ui',
    loadChildren: () => import('./features/ui/ui.module').then(m => m.UiPageModule)
  },
  {
    path: 'ruta-del-dia',
    loadChildren: () => import('./features/ruta-del-dia/ruta-del-dia.module').then(m => m.RutaDelDiaPageModule),
    canActivate: [RutaDelDiaGuard]
  },
  {
    path: 'inicio',
    loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardPageModule),
    canActivate: authOnline
  },
  {
    path: 'perfil',
    loadChildren: () => import('./features/perfil/perfil.module').then(m => m.PerfilPageModule),
    canActivate: authOnline
  },
  {
    path: 'configuracion',
    loadChildren: () => import('./features/configuracion/configuracion.module').then(m => m.ConfiguracionPageModule),
    canActivate: authConfiguracion
  },
  {
    path: 'fichas',
    loadChildren: () => import('./features/fichas/fichas.module').then(m => m.FichasPageModule),
    canActivate: authOnline
  },
  {
    path: 'visitas',
    loadChildren: () => import('./features/visitas/visitas.module').then(m => m.VisitasPageModule),
    canActivate: authOnline
  },
  {
    path: 'gestion',
    loadChildren: () => import('./features/gestion/gestion.module').then(m => m.GestionPageModule),
    canActivate: authOnline
  },
  {
    path: 'actividades-grupales',
    loadChildren: () => import('./features/actividades-grupales/actividades-grupales.module').then(m => m.ActividadesGrupalesPageModule),
    canActivate: authOnline
  },
  {
    path: 'mantenedor/asesorias-especializadas',
    redirectTo: 'actividades-grupales',
    pathMatch: 'full'
  },
  {
    path: 'mantenedor/plan-inversiones',
    loadChildren: () => import('./features/plan-inversiones/plan-inversiones.module').then(m => m.PlanInversionesPageModule),
    canActivate: authOnline
  },
  {
    path: 'mantenedor/copago',
    loadChildren: () => import('./features/copago/copago.module').then(m => m.CopagoPageModule),
    canActivate: authOnline
  },
  {
    path: 'reportes',
    loadChildren: () => import('./features/reportes/reportes.module').then(m => m.ReportesPageModule),
    canActivate: authOnline
  },
  {
    path: 'analisis',
    loadChildren: () => import('./features/analisis/analisis.module').then(m => m.AnalisisPageModule),
    canActivate: authOnline
  },
  {
    path: 'ayuda',
    loadChildren: () => import('./features/ayuda/ayuda.module').then(m => m.AyudaPageModule),
    canActivate: authOnline
  },
  {
    path: 'acceso-denegado',
    loadChildren: () => import('./features/auth/acceso-denegado/acceso-denegado.module').then( m => m.AccesoDenegadoPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadGestionStrategy })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
